import { FileActionButton } from "../file-action/file-action-controls";
import { useState, Suspense, useRef, useEffect } from 'react';
import AppLoading from '../app-loading/app-loading';
import orderServices from '../../services/orders/orderservice';
import CashCollectionListDataTable from './cash-collection-report-dataTabel';
import CashCollectionReportListSearch from './cash-collection-report-search';
import { Card } from 'primereact/card';
import { Toast } from 'primereact/toast';
import { Dialog } from "primereact/dialog";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import PaymentLinkResendList from '../resend-payment-link/resend-payment-link-list';
import CashDataTable from '../cash-report-detail/cash-Datatable';
import OnlinePaymentDataTable from '../onlinepayment-report-detail/onlinepayment-dataTable';
import { AccountReceivableExport } from '../resend-payment-link/AccountReceivableExport';
import { OnlinePaymentExport } from '../onlinepayment-report-detail/OnlinePaymentExport';
import { CashDetailExport } from '../cash-report-detail/CashDetailExport';
import SimpleBar from 'simplebar-react';
import 'simplebar-react/dist/simplebar.min.css';
import './cash-collection-report.css';

const CashDeposite: React.FC = () => {

    const [loading, setLoading] = useState(false);
    const toast = useRef<Toast>(null);
    const [dataList, setDataList] = useState<any[]>([]);
    const [sumofSales, setSumofSales] = useState<number>(0);
    const [sumofCash, setSumofCash] = useState<number>(0);
    const [sumofOnline, setSumofOnline] = useState<number>(0);
    const [sumofCredit, setSumofCredit] = useState<number>(0);
    const [sumofRewardPoints, setSumofRewardPoints] = useState<number>(0);
    const [visible, setVisible] = useState(false);
    const [startDate, setStartDate] = useState<any>();
    const [endDate, setEndDate] = useState<any>();
    const [userId, setUserId] = useState<any>(null);
    const [cashvisible, setCashvisible] = useState<boolean>(false);
    const [onlinevisible, setOnlinevisible] = useState<boolean>(false);
    const [orderIds, setOrderIds] = useState<any>();
    // lifted export data
    const [arExportData, setArExportData] = useState<any[]>([]);
    const [arFlagCache, setArFlagCache] = useState<Record<number, any | null>>({});
    const [onlineExportData, setOnlineExportData] = useState<any[]>([]);
    const [cashExportData, setCashExportData] = useState<any[]>([]);
    // Reward breakdown dialog state
    const [rewardVisible, setRewardVisible] = useState<boolean>(false);
    const [rewardBreakdownData, setRewardBreakdownData] = useState<any[]>([]);
    const [rewardTotalAmount, setRewardTotalAmount] = useState<number>(0);
    const [rewardLoading, setRewardLoading] = useState<boolean>(false);
    const [rewardTotalRecords, setRewardTotalRecords] = useState<number>(0);
    const [rewardFirst, setRewardFirst] = useState<number>(0);
    const [rewardRows, setRewardRows] = useState<number>(10);
    const [rewardSortField, setRewardSortField] = useState<string>('invoiceDate');
    const [rewardSortOrder, setRewardSortOrder] = useState<1 | -1>(-1);
    const [refreshCount, setRefreshCount] = useState(0);

    const refreshData = () => {
        setRefreshCount(prev => prev + 1);
        handelInvoiceUserChange({ startDate, endDate, userId });
    }

    const fetchOrderIds = async () => {
        try {
            const orderIdList = await orderServices.GetPullPaymentStatusLogs();
            setOrderIds(orderIdList);
        } catch (err) {
            console.error(err);
        }
    }

    useEffect(() => {
        fetchOrderIds();
    }, []);

    const handelInvoiceUserChange = async (data: any) => {
        setStartDate(data.startDate);
        setEndDate(data.endDate);
        setUserId(data.userId);

        if (!data.startDate || !data.endDate) {
            toast.current?.show({
                severity: 'info',
                summary: 'Info',
                detail: 'Please select the Date filter.',
                life: 3000
            });
            return;
        }

        if (!data.userId && !data.startDate && !data.endDate) {
            // No filter applied, clear data
            setDataList([]);
            setSumofSales(0);
            setSumofCash(0);
            setSumofOnline(0);
            setSumofCredit(0);
            setSumofRewardPoints(0);
            setLoading(false);
            return;
        }

        setLoading(true);
        try {
            const response: any = await orderServices.getCashCollectionReport(data);

            if (response.dataLists && response.dataLists.length > 0) {
                setDataList(response.dataLists);
                const cash = response.dataLists.reduce((acc: any, row: any) => acc + (row.cashAmount || 0), 0);
                const online = response.dataLists.reduce((acc: any, row: any) => acc + (row.paymentAmount || 0), 0);
                const credit = response.dataLists.reduce((acc: any, row: any) => acc + (row.credit || 0), 0);
                const reward = response.dataLists.reduce((acc: any, row: any) => acc + (row.totalRewardAmount || 0), 0);

                setSumofCash(cash);
                setSumofOnline(online);
                setSumofCredit(credit);
                setSumofRewardPoints(reward);
                setSumofSales(cash + online + credit + reward);
            } else {
                setDataList([]);
                setSumofSales(0);
                setSumofCash(0);
                setSumofOnline(0);
                setSumofCredit(0);
                setSumofRewardPoints(0);
            }
        } catch (err) {
            console.error(err);
            setDataList([]);
            setSumofSales(0);
            setSumofCash(0);
            setSumofOnline(0);
            setSumofCredit(0);
            setSumofRewardPoints(0);
        } finally {
            setLoading(false);
        }
    }

    const hideDialog = () => setVisible(false);
    const cashhideDialog = () => setCashvisible(false);
    const onlinehideDialog = () => setOnlinevisible(false);

    const handelShowPaymentLInk = () => dataList.length > 0 && setVisible(true);
    const handelCash = () => dataList.length > 0 && setCashvisible(true);
    const handelOnline = () => dataList.length > 0 && setOnlinevisible(true);

    const fetchRewardBreakdown = async (firstRow: number, numRows: number, sortBy?: string, sortDir?: string) => {
        setRewardLoading(true);
        try {
            const pageNumber = Math.floor(firstRow / numRows) + 1;
            const apiSortBy = sortBy ?? rewardSortField;
            const apiSortDir = sortDir ?? (rewardSortOrder === 1 ? 'asc' : 'desc');
            const res = await orderServices.getCollectionRewardBreakdown({
                startDate, endDate, userId, pageNumber, pageSize: numRows,
                sortBy: apiSortBy,
                sortDirection: apiSortDir
            });
            setRewardBreakdownData(res?.items ?? []);
            setRewardTotalAmount(res?.totalRewardAmount ?? 0);
            setRewardTotalRecords(res?.totalRecords ?? 0);
            setRewardFirst(firstRow);
            setRewardRows(numRows);
        } catch (err) {
            console.error(err);
            setRewardBreakdownData([]);
            setRewardTotalAmount(0);
            setRewardTotalRecords(0);
        } finally {
            setRewardLoading(false);
        }
    };

    const handelReward = async () => {
        if (dataList.length === 0) return;
        setRewardVisible(true);
        await fetchRewardBreakdown(0, 10);
    };

    const onRewardPage = (event: any) => {
        fetchRewardBreakdown(event.first, event.rows);
    };

    const onRewardSort = (event: any) => {
        const newSortField: string = event.sortField;
        const newSortOrder: 1 | -1 = event.sortOrder;
        setRewardSortField(newSortField);
        setRewardSortOrder(newSortOrder);
        // map the DataTable camelCase field to the backend key
        const fieldMap: Record<string, string> = {
            orderID: 'orderid',
            orderInvoiceID: 'invoiceid',
            invoiceNo: 'invoiceno',
            invoiceDate: 'InvoiceDate',
            grossAmount: 'grossamount',
            rewardAmount: 'rewardamount',
        };
        const apiSortBy = fieldMap[newSortField] ?? newSortField;
        const apiSortDir = newSortOrder === 1 ? 'asc' : 'desc';
        fetchRewardBreakdown(0, rewardRows, apiSortBy, apiSortDir);
    };

    return (
        <Suspense fallback={<AppLoading />}>
            <div className="layout-content mt-3 mb-3 grid grid-table-mobile">
                <Toast ref={toast} position="top-right" />
                <div className="card w-full p-4">
                    {/* LIGHT GREEN INNER SECTION FOR HEADER AND FILTERS */}
                    <div className="card p-4 w-full mb-4" style={{ backgroundColor: '#e8f5e9', borderRadius: '12px' }}>
                        {/* Page Header */}
                        <div className="collection-swipe-header-gradient">
                            <div className="collection-swipe-header-icon">
                                <i className="pi pi-chart-bar"></i>
                            </div>
                            <div className="collection-swipe-header-text">
                                <h5>Collection Report</h5>
                                <p>Monitor sales, cash, online, and credit history</p>
                            </div>
                        </div>

                        {/* Filter Section */}
                        <div className="flex align-items-center gap-2 mb-3">
                            <i className="pi pi-filter" style={{ color: 'rgb(76, 175, 80)', fontSize: '1.1rem' }}></i>
                            <span style={{ fontWeight: '600', color: '#2d3748', fontSize: '0.95rem' }}>Filter Report</span>
                        </div>
                        <CashCollectionReportListSearch onSearch={handelInvoiceUserChange} />
                    </div>

                    {/* Metric Cards Grid */}
                    <div className="collectionMetricsGrid mb-4">
                        {/* Total Sales */}
                        <div className="collectionMetricCard collectionMetricTotal">
                            <div className="collectionMetricContent">
                                <div className="collectionMetricIcon">
                                    <i className="pi pi-chart-line"></i>
                                </div>
                                <div className="collectionMetricInfo">
                                    <span className="collectionMetricLabel">Total Sales</span>
                                    <span className="collectionMetricValue">
                                        {Math.round(sumofSales).toLocaleString('en-gb', { style: 'currency', currency: 'INR' })}
                                    </span>
                                    <span className="collectionMetricPercent">
                                        {sumofSales > 0 ? "100%" : "0%"}
                                    </span>
                                </div>
                            </div>
                        </div>
                        {/* Cash */}
                        <div className="collectionMetricCard collectionMetricCash" onClick={handelCash}>
                            <div className="collectionMetricContent">
                                <div className="collectionMetricIcon">
                                    <i className="pi pi-money-bill"></i>
                                </div>
                                <div className="collectionMetricInfo">
                                    <span className="collectionMetricLabel">Cash</span>
                                    <span className="collectionMetricValue">
                                        {Math.round(sumofCash).toLocaleString('en-gb', { style: 'currency', currency: 'INR' })}
                                    </span>
                                    <span className="collectionMetricPercent">
                                        {sumofCash > 0 ? ((sumofCash / sumofSales) * 100).toFixed(2) + "%" : "0%"}
                                    </span>
                                </div>
                            </div>
                        </div>
                        {/* Online */}
                        <div className="collectionMetricCard collectionMetricOnline" onClick={handelOnline}>
                            <div className="collectionMetricContent">
                                <div className="collectionMetricIcon">
                                    <i className="pi pi-credit-card"></i>
                                </div>
                                <div className="collectionMetricInfo">
                                    <span className="collectionMetricLabel">Online</span>
                                    <span className="collectionMetricValue">
                                        {Math.round(sumofOnline).toLocaleString('en-gb', { style: 'currency', currency: 'INR' })}
                                    </span>
                                    <span className="collectionMetricPercent">
                                        {sumofOnline > 0 ? ((sumofOnline / sumofSales) * 100).toFixed(2) + "%" : "0%"}
                                    </span>
                                </div>
                            </div>
                        </div>
                        {/* Credit */}
                        <div className="collectionMetricCard collectionMetricCredit" onClick={handelShowPaymentLInk}>
                            <div className="collectionMetricContent">
                                <div className="collectionMetricIcon">
                                    <i className="pi pi-clock"></i>
                                </div>
                                <div className="collectionMetricInfo">
                                    <span className="collectionMetricLabel">Credit</span>
                                    <span className="collectionMetricValue">
                                        {Math.round(sumofCredit).toLocaleString('en-gb', { style: 'currency', currency: 'INR' })}
                                    </span>
                                    <span className="collectionMetricPercent">
                                        {sumofCredit > 0 ? ((sumofCredit / sumofSales) * 100).toFixed(2) + "%" : "0%"}
                                    </span>
                                </div>
                            </div>
                        </div>
                        {/* Reward Points */}
                        <div className="collectionMetricCard collectionMetricReward" onClick={handelReward} style={{ cursor: dataList.length > 0 ? 'pointer' : 'default' }}>
                            <div className="collectionMetricContent">
                                <div className="collectionMetricIcon">
                                    <i className="pi pi-gift"></i>
                                </div>
                                <div className="collectionMetricInfo">
                                    <span className="collectionMetricLabel">Reward</span>
                                    <span className="collectionMetricValue">
                                        {Math.round(sumofRewardPoints).toLocaleString('en-gb', { style: 'currency', currency: 'INR' })}
                                    </span>
                                    <span className="collectionMetricPercent">
                                        {sumofRewardPoints > 0 ? ((sumofRewardPoints / sumofSales) * 100).toFixed(2) + "%" : "0%"}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <Dialog
                        visible={cashvisible}
                        style={{ width: '70vw', height: '85vh' }}
                        header={
                            <div className="report-modal-header">
                                <span>Cash Report</span>
                                <FileActionButton action="export"
                                    label="Export Excel"
                                    icon="pi pi-file-excel"
                                    className="report-modal-export-btn"
                                    onClick={() => CashDetailExport(cashExportData)}
                                    disabled={!cashExportData || cashExportData.length === 0}
                                />
                            </div>
                        }
                        onHide={cashhideDialog}
                        maximizable
                        draggable={false}
                        resizable={false}
                        contentStyle={{ display: 'flex', flexDirection: 'column', flex: 1, overflow: 'hidden', padding: 0 }}
                        pt={{
                            header: {
                                style: {
                                    background: 'linear-gradient(135deg, #4CAF50, #388e3c)',
                                    color: 'white',
                                    borderRadius: '12px 12px 0 0',
                                    padding: '0.75rem 1.5rem'
                                }
                            },
                            closeButton: { style: { color: 'white' } },
                            closeButtonIcon: { style: { color: 'white' } }
                        }}
                    >
                        <SimpleBar style={{ height: '100%' }} autoHide={false} className="report-modal-simplebar">
                            <CashDataTable
                                dateFilter={{ startDate, endDate, userId, collectionType: 1 }}
                                onDataLoaded={setCashExportData}
                            />
                        </SimpleBar>
                    </Dialog>

                    <Dialog
                        visible={onlinevisible}
                        style={{ width: '70vw', height: '85vh' }}
                        header={
                            <div className="report-modal-header">
                                <span>Online Payment Report</span>
                                <FileActionButton action="export"
                                    label="Export Excel"
                                    icon="pi pi-file-excel"
                                    className="report-modal-export-btn"
                                    onClick={() => OnlinePaymentExport(onlineExportData)}
                                    disabled={!onlineExportData || onlineExportData.length === 0}
                                />
                            </div>
                        }
                        onHide={onlinehideDialog}
                        maximizable
                        draggable={false}
                        resizable={false}
                        contentStyle={{ display: 'flex', flexDirection: 'column', flex: 1, overflow: 'hidden', padding: 0 }}
                        pt={{
                            header: {
                                style: {
                                    background: 'linear-gradient(135deg, #4CAF50, #388e3c)',
                                    color: 'white',
                                    borderRadius: '12px 12px 0 0',
                                    padding: '0.75rem 1.5rem'
                                }
                            },
                            closeButton: { style: { color: 'white' } },
                            closeButtonIcon: { style: { color: 'white' } }
                        }}
                    >
                        <SimpleBar style={{ height: '100%' }} autoHide={false} className="report-modal-simplebar">
                            <OnlinePaymentDataTable
                                dateFilter={{ startDate, endDate, userId, collectionType: 2 }}
                                onDataLoaded={setOnlineExportData}
                            />
                        </SimpleBar>
                    </Dialog>

                    <Dialog
                        visible={visible}
                        style={{ width: '92vw', maxWidth: '1400px', height: '85vh' }}
                        header={
                            <div className="report-modal-header">
                                <span>Account Receivable Report</span>
                                <FileActionButton action="export"
                                    label="Export Excel"
                                    icon="pi pi-file-excel"
                                    className="report-modal-export-btn"
                                    onClick={() => AccountReceivableExport(arExportData, arFlagCache)}
                                    disabled={!arExportData || arExportData.length === 0}
                                />
                            </div>
                        }
                        onHide={hideDialog}
                        maximizable
                        draggable={false}
                        resizable={false}
                        contentStyle={{ display: 'flex', flexDirection: 'column', flex: 1, overflow: 'hidden', padding: 0 }}
                        pt={{
                            header: {
                                style: {
                                    background: 'linear-gradient(135deg, #4CAF50, #388e3c)',
                                    color: 'white',
                                    borderRadius: '12px 12px 0 0',
                                    padding: '0.75rem 1.5rem'
                                }
                            },
                            closeButton: { style: { color: 'white' } },
                            closeButtonIcon: { style: { color: 'white' } }
                        }}
                    >
                        <SimpleBar style={{ height: '100%' }} autoHide={false} className="report-modal-simplebar">
                            <PaymentLinkResendList
                                dateFilter={{ startDate, endDate, userId }}
                                onDataLoaded={setArExportData}
                                onFlagCacheUpdate={setArFlagCache}
                                refreshCount={refreshCount}
                                onPaymentSuccess={refreshData}
                            />
                        </SimpleBar>
                    </Dialog>

                    {/* Reward Breakdown Dialog */}
                    <Dialog
                        visible={rewardVisible}
                        style={{ width: '75vw', height: '85vh' }}
                        header={
                            <div className="report-modal-header">
                                <span>Reward Breakdown</span>
                                <span style={{ fontSize: '0.95rem', fontWeight: '600', color: 'white', background: 'rgba(255,255,255,0.2)', padding: '2px 12px', borderRadius: '20px' }}>
                                    Total: {Math.round(rewardTotalAmount).toLocaleString('en-gb', { style: 'currency', currency: 'INR' })}
                                </span>
                            </div>
                        }
                        onHide={() => setRewardVisible(false)}
                        maximizable
                        draggable={false}
                        resizable={false}
                        contentStyle={{ display: 'flex', flexDirection: 'column', flex: 1, overflow: 'hidden', padding: 0 }}
                        pt={{
                            header: {
                                style: {
                                    background: 'linear-gradient(135deg, #4CAF50, #388e3c)',
                                    color: 'white',
                                    borderRadius: '12px 12px 0 0',
                                    padding: '0.75rem 1.5rem'
                                }
                            },
                            closeButton: { style: { color: 'white' } },
                            closeButtonIcon: { style: { color: 'white' } }
                        }}
                    >
                        <SimpleBar style={{ height: '100%' }} autoHide={false} className="report-modal-simplebar">
                            <DataTable
                                value={rewardBreakdownData}
                                loading={rewardLoading}
                                emptyMessage="No reward data found."
                                lazy
                                paginator
                                first={rewardFirst}
                                rows={rewardRows}
                                totalRecords={rewardTotalRecords}
                                onPage={onRewardPage}
                                rowsPerPageOptions={[10, 20, 50]}
                                paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                                currentPageReportTemplate="{first} to {last} of {totalRecords}"
                                responsiveLayout="scroll"
                                style={{ padding: '1rem' }}
                                stripedRows
                                sortField={rewardSortField}
                                sortOrder={rewardSortOrder}
                                onSort={onRewardSort}
                            >
                                <Column field="orderID" header="Order ID" sortable style={{ minWidth: '100px' }} />
                                <Column field="orderInvoiceID" header="Invoice ID" sortable style={{ minWidth: '110px' }} />
                                <Column field="invoiceNo" header="Invoice No." sortable style={{ minWidth: '110px' }} />
                                <Column
                                    field="invoiceDate"
                                    header="Invoice Date"
                                    sortable
                                    style={{ minWidth: '130px' }}
                                    body={(row) => row.invoiceDate ? new Date(row.invoiceDate).toLocaleDateString('en-GB') : '-'}
                                />
                                <Column field="customerName" header="Customer" sortable style={{ minWidth: '160px' }} />
                                <Column field="primaryContactNo" header="Ph No" sortable style={{ minWidth: '130px' }} />
                                <Column
                                    field="grossAmount"
                                    header="Gross Amount"
                                    sortable
                                    style={{ minWidth: '130px' }}
                                    body={(row) => Math.round(row.grossAmount).toLocaleString('en-gb', { style: 'currency', currency: 'INR' })}
                                />
                                <Column
                                    field="rewardAmount"
                                    header="Reward Amount"
                                    sortable
                                    style={{ minWidth: '130px' }}
                                    body={(row) => <span style={{ color: '#16a34a', fontWeight: 600 }}>{Math.round(row.rewardAmount).toLocaleString('en-gb', { style: 'currency', currency: 'INR' })}</span>}
                                />
                            </DataTable>
                        </SimpleBar>
                    </Dialog>

                    <div className="mb-2">
                        <h5 style={{ fontWeight: '600', color: '#10492a', marginBottom: '1rem' }}>Collection History</h5>
                        <CashCollectionListDataTable data={dataList} />
                    </div>
                </div>
            </div>
            {loading && <AppLoading />}
        </Suspense>
    )
}

export default CashDeposite;